import type { StateEditFormProps } from "./state-edit-form.type";

import { Form, Spin } from "antd";
import { useEffect, useMemo } from "react";

import { useStateTransition } from "@/hooks/queries";
import { useAuthorization } from "@/modules/authorization";
import { StateEditField } from "@/modules/state-edit-field";

const { useForm } = Form;

export const StateEditForm = ({
  model,
  stateType,
  disabled,
}: StateEditFormProps) => {
  const [form] = useForm();
  const { canUpdateItem } = useAuthorization();

  const { mutate, isPending: isLoading } = useStateTransition(
    stateType,
    model.id
  );

  const defaultValues = useMemo(() => ({ state: model.state }), [model.state]);

  useEffect(() => {
    form.setFieldsValue(defaultValues);
  }, [form, defaultValues]);

  return (
    <Spin spinning={isLoading}>
      <Form form={form} layout="vertical" initialValues={defaultValues}>
        <StateEditField
          name="state"
          type={stateType}
          model={model}
          onChange={(state) => mutate(state)}
          disabled={disabled || !canUpdateItem(model)}
          noMarginBottom
        />
      </Form>
    </Spin>
  );
};
